import * as i0 from '@angular/core';
import { inject, Injectable, input, computed, ChangeDetectionStrategy, Component } from '@angular/core';
import { EffySite } from '@effy-tech/angular-common/site';
import { EFFY_ENVIRONMENT } from '@effy-tech/angular-common/environment';
import { EFFY_WS_CONFIG } from '@effy-tech/angular-common/web-service';

var EffyLogoType;
(function (EffyLogoType) {
    EffyLogoType["ALT"] = "alt";
    EffyLogoType["BASE"] = "base";
    EffyLogoType["DEFAULT"] = "default";
    EffyLogoType["WHITE"] = "white";
})(EffyLogoType || (EffyLogoType = {}));
const SITE_MAPPER_PREFIX_URL = {
    [EffySite.CALCULEO]: 'calculeo',
    [EffySite.EFFY]: 'effy',
    [EffySite.LAPRIMEENERGIE]: 'lpe',
    [EffySite.QUELLEENERGIE]: 'qe',
    [EffySite.PRO]: 'pro',
    [EffySite.PRO_SERENITE]: 'pro-serenite',
};

/**
 * /!\ Effy Logo Service for new Direction Artistic only
 */
class EffyLogoService {
    constructor() {
        this.env = inject(EFFY_ENVIRONMENT);
    }
    getUrl(site, type) {
        return `${EFFY_WS_CONFIG.commonAssets[this.env]}images/logos/${SITE_MAPPER_PREFIX_URL[site]}/logo_${SITE_MAPPER_PREFIX_URL[site].replace('-', '_')}_${type}.svg`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: EffyLogoService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: EffyLogoService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: EffyLogoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class EffyLogoComponent {
    constructor() {
        this.site = input(EffySite.EFFY);
        this.type = input(EffyLogoType.DEFAULT);
        this.alt = input();
        this.width = input.required();
        this.height = input.required();
        this.loading = input.required();
        this.logoService = inject(EffyLogoService);
        this.logUrl = computed(() => this.logoService.getUrl(this.site(), this.type()));
        this.computedAlt = computed(() => this.alt() ?? `${this.site()} logo`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: EffyLogoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "19.2.13", type: EffyLogoComponent, isStandalone: true, selector: "effy-logo", inputs: { site: { classPropertyName: "site", publicName: "site", isSignal: true, isRequired: false, transformFunction: null }, type: { classPropertyName: "type", publicName: "type", isSignal: true, isRequired: false, transformFunction: null }, alt: { classPropertyName: "alt", publicName: "alt", isSignal: true, isRequired: false, transformFunction: null }, width: { classPropertyName: "width", publicName: "width", isSignal: true, isRequired: true, transformFunction: null }, height: { classPropertyName: "height", publicName: "height", isSignal: true, isRequired: true, transformFunction: null }, loading: { classPropertyName: "loading", publicName: "loading", isSignal: true, isRequired: true, transformFunction: null } }, ngImport: i0, template: "<img [attr.src]=\"logUrl()\" [attr.width]=\"width()\" [attr.height]=\"height()\" [attr.loading]=\"loading()\" [attr.alt]=\"computedAlt()\" />\n", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: EffyLogoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'effy-logo', changeDetection: ChangeDetectionStrategy.OnPush, template: "<img [attr.src]=\"logUrl()\" [attr.width]=\"width()\" [attr.height]=\"height()\" [attr.loading]=\"loading()\" [attr.alt]=\"computedAlt()\" />\n" }]
        }] });

class EffyLogoServiceMock {
    getUrl() {
        return ``;
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { EffyLogoComponent, EffyLogoService, EffyLogoServiceMock, EffyLogoType, SITE_MAPPER_PREFIX_URL };
